import { firstJuly2025ArticleCard } from 'constants/articles/first-july-2025-article';
import { secondJuly2025ArticleCard } from 'constants/articles/second-july-2025-article';
import { forthJuly2025ArticleCard } from 'constants/articles/forth-july-2025-article';
import { firstAugust2025ArticleCard } from 'constants/articles/first-august-2025-article';
import { secondAugust2025ArticleCard } from 'constants/articles/second-august-2025-article';
import { thirdAugust2025ArticleCard } from 'constants/articles/third-august-2025-article';
import { forthAugust2025ArticleCard } from 'constants/articles/forth-august-2025-article';
import { firstSeptember2025ArticleCard } from 'constants/articles/first-september-2025-article';
import { secondSeptember2025ArticleCard } from 'constants/articles/second-september-2025-article';
import { thirdSeptember2025ArticleCard } from 'constants/articles/third-september-2025-article';
import { waveSensePartnershipCard } from 'constants/partnership/wave-sense';
import { amdSiloPartnershipCard } from 'constants/partnership/amd-silo';

import { TCardProps } from 'types/common';

import FirstLinkedInPostImage from 'assets/linked-in-posts/first-linkedin-post.webp';
import SecondLinkedInPostImage from 'assets/linked-in-posts/second-linked-in-post.webp';
import ThirdLinkedInPostImage from 'assets/linked-in-posts/third-linked-in-post.webp';
import ForthLinkedInPostImage from 'assets/linked-in-posts/forth-linked-in-post.webp';
import FifthLinkedInPostImage from 'assets/linked-in-posts/fifth-linked-in-post.webp';
import SixthLinkedInPostImage from 'assets/linked-in-posts/sixth-linked-in-post.webp';
import SeventhLinkedInPostImage from 'assets/linked-in-posts/seventh-linked-in-post.webp';
import EighthLinkedInPostImage from 'assets/linked-in-posts/eighth-linked-in-post.webp';
import { forthSeptember2025ArticleCard } from 'constants/articles/forth-september-2025-article';
import { thirdJuly2025ArticleCard } from 'constants/articles/third-july-2025-article';
import { firstSeptember2025NewsCard } from 'constants/news/first-september-2025-news';
import { aiSummitTurku2025NewsCard } from 'constants/news/ai-summit-turku-2025-news';
import { fifthSeptember2025ArticleCard } from 'constants/articles/fifth-september-2025-article';
import { firstOctober2025ArticleCard } from 'constants/articles/first-october-2025-article';
import { secondOctober2025ArticleCard } from 'constants/articles/second-october-2025-article';
import { thirdOctober2025ArticleCard } from 'constants/articles/third-october-2025-article';
import { forthOctober2025ArticleCard } from 'constants/articles/forth-october-2025-article';
import { thirdNovember2025ArticleCard } from 'constants/articles/third-november-2025-article';
import { seventhNovember2025ArticleCard } from 'constants/articles/seventh-november-2025-article';
import { tenthNovember2025ArticleCard } from 'constants/articles/tenth-november-2025-article';
import { twelvethNovember2025ArticleCard } from 'constants/articles/twelveth-november-2025-article';
import { fourteenthNovember2025ArticleCard } from 'constants/articles/fourteenth-november-2025-article';
import { seventeenthNovember2025ArticleCard } from 'constants/articles/seventeenth-november-2025-article';
import { twentiethNovember2025ArticleCard } from 'constants/articles/twentieth-november-2025-article';
import { twentyFourthNovember2025ArticleCard } from 'constants/articles/twenty-fourth-november-2025-article';
import { eightDecember2025ArticleCard } from 'constants/articles/eight-december-2025-article';
import { secondDecember2025ArticleCard } from 'constants/articles/second-december-2025-article';
import { fifteenDecember2025ArticleCard } from 'constants/articles/fifteen-december-2025-article';
import { eighteenDecember2025ArticleCard } from 'constants/articles/eighteen-december-2025-article';
import { twentyTwoDecember2025ArticleCard } from 'constants/articles/twenty-two-december-2025-article';
import { usingSyntheticDataFromAILiveSimCard } from 'constants/whitepapers/using-synthetic-data-from-AILiveSim';
import { firstDecemberAutoDocking2026ArticleCard } from 'constants/articles/first-january-2026-article';
import { secondJanuary2026ArticleCard } from 'constants/articles/second-january-2026-article';
import { classicalSimulationTestingCard } from 'constants/technical-briefs/classical-simulation-testing-doesnt-scale';

export const CARDS: TCardProps[] = [
  firstJuly2025ArticleCard,
  secondJuly2025ArticleCard,
  thirdJuly2025ArticleCard,
  forthJuly2025ArticleCard,
  firstAugust2025ArticleCard,
  secondAugust2025ArticleCard,
  thirdAugust2025ArticleCard,
  forthAugust2025ArticleCard,
  firstSeptember2025ArticleCard,
  secondSeptember2025ArticleCard,
  fifthSeptember2025ArticleCard,
  thirdSeptember2025ArticleCard,
  waveSensePartnershipCard,
  amdSiloPartnershipCard,
  forthSeptember2025ArticleCard,
  firstSeptember2025NewsCard,
  aiSummitTurku2025NewsCard,
  firstOctober2025ArticleCard,
  secondOctober2025ArticleCard,
  thirdOctober2025ArticleCard,
  forthOctober2025ArticleCard,
  thirdNovember2025ArticleCard,
  seventhNovember2025ArticleCard,
  tenthNovember2025ArticleCard,
  twelvethNovember2025ArticleCard,
  fourteenthNovember2025ArticleCard,
  seventeenthNovember2025ArticleCard,
  twentiethNovember2025ArticleCard,
  twentyFourthNovember2025ArticleCard,
  eightDecember2025ArticleCard,
  secondDecember2025ArticleCard,
  fifteenDecember2025ArticleCard,
  eighteenDecember2025ArticleCard,
  twentyTwoDecember2025ArticleCard,
  usingSyntheticDataFromAILiveSimCard,
  firstDecemberAutoDocking2026ArticleCard,
  secondJanuary2026ArticleCard,
  classicalSimulationTestingCard,
];

interface LinkedInPost {
  imageSrc: string;
  postUrl: string;
}

export const LINKED_IN_POSTS: LinkedInPost[] = [
  {
    imageSrc: FirstLinkedInPostImage,
    postUrl: 'https://www.linkedin.com/feed/update/urn:li:activity:7398676805416628224',
  },
  {
    imageSrc: SecondLinkedInPostImage,
    postUrl: 'https://www.linkedin.com/feed/update/urn:li:activity:7396828258337554432',
  },
  {
    imageSrc: ThirdLinkedInPostImage,
    postUrl: 'https://www.linkedin.com/feed/update/urn:li:activity:7395090654848077825',
  },
  {
    imageSrc: ForthLinkedInPostImage,
    postUrl: 'https://www.linkedin.com/feed/update/urn:li:activity:7393652424378318848',
  },
  {
    imageSrc: FifthLinkedInPostImage,
    postUrl:
      'https://www.linkedin.com/posts/ailivesim_ailivesim-simulation-autonomousvessels-activity-7382385954214383616-tCMl?utm_source=share&utm_medium=member_desktop&rcm=ACoAAD4KmiMB_KCom6pG8R8TEKjKH4ihnkh6DKM',
  },
  {
    imageSrc: SixthLinkedInPostImage,
    postUrl:
      'https://www.linkedin.com/posts/ailivesim_aiinnovation-simulationintheloop-dataacquisition-activity-7374676147143528449-TH8-?utm_source=share&utm_medium=member_desktop&rcm=ACoAAD4KmiMB_KCom6pG8R8TEKjKH4ihnkh6DKM',
  },
  {
    imageSrc: SeventhLinkedInPostImage,
    postUrl:
      'https://www.linkedin.com/posts/ailivesim_slush2025-ailivesim-ai-activity-7397281063041052672-Y6yt?utm_source=share&utm_medium=member_desktop&rcm=ACoAAD4KmiMB_KCom6pG8R8TEKjKH4ihnkh6DKM',
  },
  {
    imageSrc: EighthLinkedInPostImage,
    postUrl:
      'https://www.linkedin.com/posts/ailivesim_autonomousships-simulation-maritimeai-activity-7374359055701663745-qGCx?utm_source=share&utm_medium=member_desktop&rcm=ACoAAD4KmiMB_KCom6pG8R8TEKjKH4ihnkh6DKM',
  },
];
